<form class="" [formGroup]="formGroup">
    <div class="col-12">
        <!-- NUEVO INI -->
        <div class="formInit_contacts">

            <div class="row pr-1 pl-2 altura1_7 ">
                <div class="col-4 reset ">

                    <div class="form-group_terceros pr-1 datos_identificacion">
                        <label class="text-right mt-1 pix_55">{{ "labels.name" | translate }} :</label>
                        <input (blur)="blurElement('Name2')" placeholder="{{placeholderName2}}"
                            [attr.disabled]="formMode || !modoEdicion? true: null" maxlength="50"
                            formControlName="Name2" [ngClass]="{
                  'form-error' :comprobarErrores('Name2') === 1,
                  'form-no-valid' : comprobarErrores('Name2') === 2}" type="text"
                            class="form-control anchurax60 float-right" />
                    </div>

                </div>
                <div class="col-4 reset">

                    <div class="form-group_terceros pr-1 datos_identificacion">
                        <label class="text-right mt-1 pix_55">{{ "labels.apellido1" | translate }} :</label>
                        <input (blur)="blurElement('LastName1')" placeholder="{{placeholderLastName1}}"
                            [attr.disabled]="formMode || !modoEdicion? true: null" maxlength="50"
                            formControlName="LastName1" [ngClass]="{
                  'form-error' :comprobarErrores('LastName1') === 1,
                  'form-no-valid' : comprobarErrores('LastName1') === 2}" type="text"
                            class="form-control  anchurax60 float-right" />

                    </div>

                </div>
                <div class="col-4 reset ">
                    <div class="form-group_terceros pr-1 datos_identificacion">
                        <label class="text-right mt-1 pix_55 text-not-over text-not-over pix_55"
                            title="{{'labels.apellido2' | translate }}">{{ "labels.apellido2" | translate }}
                            :</label>
                        <input [attr.disabled]="formMode || !modoEdicion? true: null" maxlength="50"
                            formControlName="LastName2" type="text" class="form-control  anchurax60 float-right" />
                    </div>
                </div>
            </div>
            <div class="row  pr-1 pl-2 altura1_7 ">
                <div class="col-4 reset ">
                    <div class="form-group_terceros pr-1 datos_identificacion">
                        <label class="text-right mt-1 pix_55">
                            {{ "labels.cargo" | translate }} :</label>
                        <input [attr.disabled]="formMode || !modoEdicion? true: null" maxlength="50"
                            formControlName="Post" type="text" class="form-control anchurax60 float-right" />
                    </div>
                </div>
                <div class="col-4 reset ">
                    <div class="pr-1">
                        <div class="form-group_terceros datos_identificacion"
                            [ngClass]="{ 'popoverClassic_blue': blurElementError('Phone')  }">
                            <label class="text-right pix_55 text-not-over mt-1" title="{{ 'labels.telephone' | translate }} "> {{ "labels.telephone" | translate }}:</label>
              <input popoverPlacement=" bottom" [popoverOnHover]="true" [popover]="myPopover20"
                                (blur)="blurElement('Phone')" placeholder="{{placeholderPhone}}"
                                [attr.disabled]="formMode || !modoEdicion? true: null" maxlength="20"
                                formControlName="Phone" [ngClass]="{
                  'form-error' :comprobarErrores('Phone') === 1,
                  'form-no-valid' : comprobarErrores('Phone') === 2 }" type="text"
                                class="form-control  anchurax60 float-right" appDigitOnly />
                            <popover-content #myPopover20>
                                <div class="body-tooltip" *ngIf="blurElementError('Phone')">
                                    <span
                                        [innerHtml]="'errors.required.formatoErroneo' | translate | returnHtml: 'html'"></span>
                                </div>
                            </popover-content>
                        </div>

                    </div>
                </div>
                <div class="col-4 reset ">
                    <div class="form-group_terceros pr-1 datos_identificacion">
                        <label class="text-right mt-1 pix_55">{{ "labels.fax" | translate }} :</label>
                        <input appDigitOnly [attr.disabled]="formMode || !modoEdicion? true: null" maxlength="20"
                            formControlName="Fax" type="text" class="form-control  anchurax60 float-right" />
                    </div>
                </div>
            </div>





            <div class="row pr-1 pl-2 altura1_7 ">
                <div class="col-4 reset ">
                    <div class="form-group_terceros datos_identificacion pr-1">
                        <label class="text-right mt-1 pix_55 text-not-over">{{ "labels.email" | translate }}
                            :</label>
                        <input (blur)="blurElementMail('Email')" placeholder="{{placeholderEmail}}"
                            [attr.disabled]="formMode || !modoEdicion? true: null" formControlName="Email"
                            [ngClass]="{  'form-no-valid':  hasErrorInvalid('Email')}" maxlength="50" type="text"
                            class="form-control  anchurax60 float-right " />
                    </div>

                </div>
                <div class="col-4 reset ">
                    <div class="form-group_terceros pr-1 datos_identificacion">
                        <label title="{{ 'labels.pagina_web' | translate }} "
                            class="text-right mt-1 pix_55 text-not-over">{{ 'labels.pagina_web' | translate }}:</label>
                        <input [attr.disabled]="formMode || !modoEdicion? true: null" maxlength="50"
                            formControlName="Webpage" type="text" class="form-control  anchurax60 float-right" />
                    </div>
                </div>
            </div>

            <div class="row pr-1 pl-2  ">
                <div class="col-12 reset ">
                    <div class="form-group_terceros pr-1 datos_identificacion">
                        <label class="text-right mt-1 pix_55">{{ "labels.notas" | translate }} :</label>
                        <textarea [attr.disabled]="formMode || !modoEdicion? true: null" maxLength="50"
                            formControlName="Notes" class="anchurax70 form-control-sm notas mr-4 mb-1 mt-1
               form-control noResize " kendoTextArea>
            </textarea>
                    </div>
                </div>
            </div>
        </div>

        <!-- NUEVO FIN -->


        <!-- Botones -->
        <div class="row mb-2 justify-content-between">
            <!-- popover busqueda -->
            <div class="popoverClassic popoverClassic_3" *ngIf="activarLamparita">
                <button class="btn-toolbar intoTable pos_3" popoverPlacement="top" [popoverOnHover]="false"
                    [popoverCloseOnClickOutside]="true" [popover]="myPopover1" role="button">
                    <i class="fa fa-lightbulb-o"></i>
                </button>

                <popover-content #myPopover1 [closeOnClickOutside]="true">
                    <div class="body-tooltip popover_mod_2 mod1">
                        <span [innerHtml]="
                  'gestion_terceros.popover.contactos'
                    | translate
                    | returnHtml: 'html'  "></span>
                    </div>
                </popover-content>
            </div>

            <div class="col-12 form-group_terceros altura1_7">


                <button *ngIf="botonAnadir" type="button" class="btn btn-secondary verde  pix_100  " (click)="anadir()"
                    [disabled]="comprobarCampos()">
                    {{ "labels.anadir" | translate }}<span class="k-icon k-i-plus"></span>
                </button>

                <button [disabled]="!botonModificar && !elementoSeleccionado" type="button"
                    class="btn btn-secondary naranja pix_120" (click)="editarContacto()">
                    {{ "labels.modificar" | translate }}<span class="k-icon k-i-edit"></span>
                </button>

                <button [disabled]="!elementoSeleccionado" type="button" class="btn btn-secondary rojo pix_100 "
                    (click)="eliminarContacto()">
                    {{ "labels.eliminar" | translate }}<span class="k-icon k-i-delete k-i-trash"></span>
                </button>


                <!-- <button [disabled]="!botonGuardar" type="button" class="btn btn-secondary azul float-right pix_100"
                    (click)="guardarContactos()">
                    {{ "labels.guardar" | translate }}<span class="k-icon k-i-plus-sm"> </span>
                </button> -->


            </div>
        </div>







        <!-- TABLA  -->
        <div class="row">
            <div class="col-12">

                <kendo-grid class="home-grid" [resizable]="true" (cellClick)="selectContact($event)" [data]="gridData"
                    [navigable]="true" [height]="280">

                    <kendo-grid-column field="Name1" title="{{ 'labels.name' | translate }}"
                        [headerStyle]="{ 'background-color': '#f5f5f5' }" [width]="100" [minResizableWidth]="30">
                        <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup"
                            let-isNew="isNew">
                            <input #input class="k-textbox" [formControl]="formGroup.get(column.field)" />
                        </ng-template>
                    </kendo-grid-column>
                    <!-- Post -->
                    <kendo-grid-column field="Post" title="{{ 'labels.cargo' | translate }}"
                        [headerStyle]="{ 'background-color': '#f5f5f5' }" [width]="100" [minResizableWidth]="30">
                        <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup"
                            let-isNew="isNew">
                            <input #input class="k-textbox" [formControl]="formGroup.get(column.field)" />
                        </ng-template>
                    </kendo-grid-column>
                    <!-- Phone -->
                    <kendo-grid-column field="Phone" title="{{ 'labels.telephone' | translate }}"
                        [headerStyle]="{ 'background-color': '#f5f5f5' }" [width]="100" [minResizableWidth]="30">
                        <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup"
                            let-isNew="isNew">
                            <input #input class="k-textbox" [formControl]="formGroup.get(column.field)" />
                        </ng-template>
                    </kendo-grid-column>
                    <!-- Fax -->
                    <kendo-grid-column field="Fax" title="{{ 'labels.fax' | translate }}" [width]="100"
                        [minResizableWidth]="30" [headerStyle]="{ 'background-color': '#f5f5f5' }">
                        <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup"
                            let-isNew="isNew">
                            <input #input class="k-textbox" [formControl]="formGroup.get(column.field)" />
                        </ng-template>
                    </kendo-grid-column>
                    <!-- Email -->
                    <kendo-grid-column field="Email" title="{{ 'labels.email' | translate }}" [width]="100"
                        [minResizableWidth]="30" [headerStyle]="{ 'background-color': '#f5f5f5' }">
                        <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup"
                            let-isNew="isNew">
                            <input #input class="k-textbox" [formControl]="formGroup.get(column.field)" />
                        </ng-template>
                    </kendo-grid-column>
                    <!-- Webpage -->
                    <kendo-grid-column field="Webpage" title="{{ 'labels.pagina_web' | translate }}" [width]="100"
                        [minResizableWidth]="30" [headerStyle]="{ 'background-color': '#f5f5f5' }">
                        <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup"
                            let-isNew="isNew">
                            <input #input class="k-textbox" [formControl]="formGroup.get(column.field)" />
                        </ng-template>
                    </kendo-grid-column>
                    <!-- Notes -->
                    <kendo-grid-column field="Notes" title="{{ 'labels.notas' | translate }}" [width]="100"
                        [minResizableWidth]="30" [headerStyle]="{ 'background-color': '#f5f5f5' }">
                        <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup"
                            let-isNew="isNew">
                            <input #input class="k-textbox" [formControl]="formGroup.get(column.field)" />
                        </ng-template>
                    </kendo-grid-column>
                </kendo-grid>

            </div>
        </div>

    </div>
</form>
